var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.58057 0.560547C3.73696 0.560547 0.621094 3.67641 0.621094 7.52002C0.621094 11.3636 3.73696 14.4795 7.58057 14.4795C11.4242 14.4795 14.54 11.3636 14.54 7.52002C14.54 3.67641 11.4242 0.560547 7.58057 0.560547ZM5.4709 4.5963C5.38524 4.68399 5.33788 4.80211 5.33924 4.9247C5.34074 5.04728 5.39085 5.16426 5.47855 5.24993C5.56624 5.3356 5.68436 5.38295 5.80694 5.3816L9.05179 5.34366L4.65953 9.83984C4.57379 9.92761 4.52643 10.0458 4.52787 10.1685C4.5293 10.2912 4.57941 10.4083 4.66718 10.494C4.75495 10.5798 4.87318 10.6271 4.99587 10.6257C5.11855 10.6243 5.23565 10.5742 5.32138 10.4864L9.71365 5.99021L9.75158 9.23506C9.75012 9.29717 9.76118 9.35894 9.7841 9.41668C9.80703 9.47442 9.84135 9.52696 9.88501 9.57115C9.92868 9.61534 9.9808 9.65028 10.0383 9.67389C10.0957 9.6975 10.1574 9.70929 10.2195 9.70857C10.2816 9.70784 10.3429 9.69461 10.3998 9.66966C10.4567 9.64472 10.508 9.60857 10.5507 9.56337C10.5933 9.51817 10.6264 9.46484 10.6479 9.40658C10.6695 9.34832 10.6791 9.28631 10.6762 9.22425L10.6252 4.8629C10.6237 4.74031 10.5736 4.62333 10.4859 4.53767C10.3982 4.452 10.2801 4.40464 10.1575 4.406L5.79613 4.45699C5.67355 4.4585 5.55657 4.5086 5.4709 4.5963Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.b3a63f58f2ddd9d3bd1b838f7fd27519.svg";
export { ForwardRef as ReactComponent };